import React, { useState, useEffect } from "react";
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from "react-router-dom";
import { API_BASE_URL } from "../../Constants/ApiConstants";


const UploadProductImage = () => {
    //Get Product List
    const [products, setProduct] = useState([]);

    useEffect(() => {
        loadProducts();
    }, []);

    const loadProducts = async () => {
        const result = await axios.get(`${API_BASE_URL}/v1/product/list`);
        console.log("My Data:", result.data.data)
        setProduct(result.data.data.reverse());
    };

    //Integrate Image Upload API 
    const [product_id, setProductID] = useState("");
    console.log(product_id);
    const [imageFile, setImageFile] = useState("");
    console.log(imageFile);

    const onSubmit = async e => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('product_id', product_id);
        formData.append('imageFile', imageFile);

        await axios.post(`${API_BASE_URL}/v1/product/create-image`, formData).then(response => {
            console.log("Response:", response.data.message)
            toast.success(response.data.message);

        }).catch(error => {
            console.log(error.response.data.message)
            toast.error(error.response.data.message);
        });
    };


    return (
        <div class="w-full h-screen overflow-x-hidden border-t flex flex-col">
            <ToastContainer />
            <main class="w-full flex-grow p-6">
                <h1 class="w-full text-3xl text-black pb-6">Upload Product Image</h1>
                <div className="flex flex-wrap">
                    <div className="w-full  my-6 pr-0 lg:pr-2">
                        <p className="text-xl pb-6 flex items-center">
                            <i className="fas fa-list mr-3"></i> Enter Information
                        </p>
                        <div className="leading-loose">
                            <form className="p-10 bg-white rounded shadow-xl" onSubmit={e => onSubmit(e)}>

                                <div className="mt-2">
                                    <label className="block text-sm text-gray-600" for="product">Product</label>
                                    <select required="true" class="form-select form-select-sm 
                                    appearance-none 
                                    block w-full px-2 py-1
                                     text-sm font-normal
                                     w-full px-5 py-1 text-gray-700 bg-gray-200 rounded
                                      text-gray-700 bg-white bg-clip-padding bg-no-repeat
                                      border border-solid border-gray-300
                                      rounded
                                      transition
                                      ease-in-out  m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                                      " aria-label=".form-select-lg example" onChange={(e) => setProductID(e.target.value)} name="product_id">
                                        <option>Select Product</option>
                                        {products.map((product) => (
                                            <><><option value={product.id}>{product.name}</option></></>
                                        ))}
                                    </select>
                                </div>

                                <div className="">
                                    <label className="block text-sm text-gray-600" for="imageFile">Upload Image</label>
                                    <input className="w-full px-5 py-1 text-gray-700 bg-gray-200 rounded" id="imageFile"
                                        name="imageFile"
                                        onChange={(e) => setImageFile(e.target.files[0])}
                                        type="file" required="true" aria-label="imageFile" />
                                </div>

                                <div className="mt-6">
                                    <button className="px-4 py-1 text-white font-light tracking-wider bg-gray-900 rounded" type="submit">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>

        </div>


    )
}

export default UploadProductImage
